module.exports = __webpack_public_path__ + "static/img/head_top_icon.8b9b04ad.png";